import React, { useState } from "react";
import ImageModal from "./ImageModal";
import "./AlternativeCompanyCard.css";

const AlternativeCompanyCard = ({ company, searchTerm }) => {
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  const openImageModal = () => {
    setIsImageModalOpen(true);
  };

  const closeImageModal = () => {
    setIsImageModalOpen(false);
  };

  return (
    <>
      <div className="alternative-company-card">
        <img
          src={company.image}
          alt={company.name}
          className="alternative-company-image clickable"
          onClick={openImageModal}
          onError={(e) => {
            e.target.src =
              "https://via.placeholder.com/300x200?text=Alternative+Company";
          }}
        />
        <div className="alternative-company-info">
          <h4 className="alternative-company-name">{company.name}</h4>
          <p className="alternative-company-description">
            ក្រុមហ៊ុនជម្រើសផ្សេងទៅវិញដែលគួរពិចារណា
          </p>
          {company.source && (
            <div className="alternative-company-source">
              <span className="source-label">ប្រភព:</span>
              <a
                href={company.source}
                target="_blank"
                rel="noopener noreferrer"
                className="source-link"
              >
                {company.source_label}
              </a>
            </div>
          )}
        </div>
      </div>

      {/* Image Modal */}
      <ImageModal
        isOpen={isImageModalOpen}
        image={company.image}
        title={company.name}
        onClose={closeImageModal}
      />
    </>
  );
};

export default AlternativeCompanyCard;
